import { getSubdomain } from "core/includes/location";

export const AUTH_STORAGE_KEY = 'authToken';
export const AUTH_BEARER_PREFIX = 'Bearer ';
export const AUTH_HEADER = 'Authorization';

/**
 * Number of seconds before expiry to refresh the token.
 *
 * @type {number}
 */
export const AUTH_REFRESH_LEEWAY = 60 * 5;

export const PLAN_PERIOD_MONTHLY = 'monthly';
export const PLAN_PERIOD_ANNUAL = 'annual';

export const FIRST_PAYMENT_STATUS_SUCCESS = "payment_success";
export const PAYMENT_INTENT_STATUS_SUCCEEDED = "succeeded";

export const PAYMENT_INTENT_STATUS_AUTHENTICATION_REQUIRED = "authentication_required";
export const PAYMENT_INTENT_STATUS_REQUIRES_CONFIRMATION = "requires_confirmation";
export const PAYMENT_INTENT_STATUS_REQUIRES_ACTION = "requires_action";
export const PAYMENT_INTENT_STATUS_REQUIRES_PAYMENT_METHOD = "requires_payment_method";

export const REQUIRES_ACTIONS = [
    PAYMENT_INTENT_STATUS_REQUIRES_ACTION,
    PAYMENT_INTENT_STATUS_REQUIRES_CONFIRMATION,
    PAYMENT_INTENT_STATUS_REQUIRES_PAYMENT_METHOD
];

export const CHARGE_ERROR_AUTHENTICATION_REQUIRED = "authentication_required";
export const CHARGE_ERROR_CARD_DECLINED = "card_declined";

export const PAYMENT_STATUS_COMPLETE = "complete";
export const PAYMENT_STATUS_INCOMPLETE = "incomplete";

export const CARD_ACTION_AUTHENTICATE_PAYMENT = "authenticate-payment";

export const WRITING_STRENGTH_LEVELS = {
    low: {
        percentage: 20,
        label: 'Low'
    },
    average: {
        percentage: 50,
        label: 'Average'
    },
    strong: {
        percentage: 65,
        label: 'Strong'
    },
    excellent: {
        percentage: 80,
        label: 'Excellent'
    },
};

export const DEFAULT_COUNTRY_CODE_CONFIG = {
    code: "au",
    name: "Australia",
    taxLabel: "GST",
    currency: "$",
    taxRate: 10.0
}

export const ENVIRONMENT_DEV = 'development';
export const ENVIRONMENT_UAT = 'uat';
export const ENVIRONMENT_PROD = 'production';

function getEnvironment() {
    const nodeEnv = process.env.NODE_ENV;

    if (nodeEnv !== 'production') {
        return ENVIRONMENT_DEV;
    }

    const isUat = /\buat\b/i.test(getSubdomain());
    if (isUat) {
        // It's a production build but deployed to a UAT environment.
        return ENVIRONMENT_UAT;
    }

    return  ENVIRONMENT_PROD;
}

export const environment = getEnvironment();
